import { SettingHeader } from '@affine/component/setting-components';
import { useI18n } from '@affine/i18n';

import { CanvasEdgesContent } from '../canvas-edges';
import { Edgeless } from './edgeless';
import { General } from './general';
import { Page } from './page';

export const EditorSettings = () => {
  const t = useI18n();

  return (
    <>
      <SettingHeader
        title={t['com.streamlain.settings.editorSettings.title']()}
        subtitle={t['com.streamlain.settings.editorSettings.subtitle']()}
      />
      <General />
      <Page />
      <Edgeless />
      <CanvasEdgesContent />
    </>
  );
};
